import { lazy } from "react";
import { Navigate } from "react-router-dom";
import HomePage from "../views/Home/home.js";

/****Layouts*****/
// const FullLayout = lazy(() => import("../layouts/FullLayout/FullLayout.js"));
/****End Layouts*****/

/*****Pages******/
// const Dashboard1 = lazy(() => import("../views/dashboards/Dashboard1"));
const Login = lazy(() => import("../views/Auth/Login.js"));

/*****Tables******/
// const BasicTable = lazy(() => import("../views/Finance/GL Module/index"));
// const AddGLEntry = lazy(() => import("../views/Finance/GL Module/GLForm"));

// form elements
// const ExAutoComplete = lazy(() =>
//   import("../views/FormElements/ExAutoComplete")
// );
// const ExButton = lazy(() => import("../views/FormElements/ExButton"));
// const ExCheckbox = lazy(() => import("../views/FormElements/ExCheckbox"));
// const ExRadio = lazy(() => import("../views/FormElements/ExRadio"));
// const ExSlider = lazy(() => import("../views/FormElements/ExSlider"));
// const ExSwitch = lazy(() => import("../views/FormElements/ExSwitch"));
// form layouts
// const FormLayouts = lazy(() => import("../views/FormLayouts/FormLayouts"));
// const ChartofAccount = lazy(() => import("../views/Finance/ChartofAccounts/index"));
// const GLIquiryForm = lazy(() => import("../views/Finance/GLInquiry/index"));
// const ValidateEntry = lazy(() => import("../views/Finance/GL Module/ValidateEntry"));
// const JournalReport = lazy(() => import("../views/Finance/Reports/JournalReports"));
// const GeneralLedgerReport = lazy(() => import("../views/Finance/Reports/GeneralLedgerReport"));
// const GeneralLedgerSummary = lazy(() => import("../views/Finance/Reports/GeneralLedgerSummary"));
// const TrailBalance = lazy(() => import("../views/Finance/Reports/TrialBalance"));
// const PaymentAccountDetails = lazy(() => import("../views/Finance/Payment Account Deatils/Index.js"));
// const AddPaymentAccountDetails = lazy(() => import("../views/Finance/Payment Account Deatils/PaymentAcctDetailsForm.js"));
// const DespositVoucher = lazy(() => import("../views/Finance/DepositVoucher/index"));
// const PaymentVoucher = lazy(() => import("../views/Finance/PaymentVoucher/index"));
// const AddPaymentVoucher = lazy(() => import("../views/Finance/PaymentVoucher/PaymentVoucherForm"));
// const AddDespositVoucher = lazy(() => import("../views/Finance/DepositVoucher/DepositVoucherForm"));
// const FinancialSetting = lazy(() => import("../views/Finance/Configurations/FinancialSetting"));
// const AddAccounts = lazy(() => import("../views/Finance/Configurations/AddAccounts"));
// const AddTax = lazy(() => import("../views/Finance/Configurations/AddTax"));


/*****Routes******/

const AuthRoutes = [
  {
    path: "/",
    children: [
      { path: "/", element: <Navigate to="/login" /> },
      { path: "/login", element: <Login /> },
      { path: "*", element: <Navigate to="/login" /> },
      // <Route path='*' element={<NotFound />} />

      // { path: "/form-elements/switch", element: <ExSwitch /> },
    ],
  },
];

export default AuthRoutes;
